import React from "react";
import {Link} from "react-router-dom";
import {FormattedMessage, FormattedHTMLMessage, injectIntl} from 'react-intl';
import i18n from "../../../main/i18n";

export default injectIntl(props => {

  const msg = i18n.getMsg(props.intl);
  const customerName = msg(`customer.${process.env.REACT_APP_CUSTOMER}`);

  return (
    <React.Fragment>

      <h1 className="page-title">
        <FormattedMessage id="guidance.title" defaultMessage="Guidance"/>
      </h1>

      <ol>
        <li>
          <FormattedMessage id="guidance.body1"
                            defaultMessage='Make sure you can use this {customerName} app. If in doubt {link}'
                            values={{customerName: customerName, link: <Link to="/contacts">use contacts</Link>}}/>
        </li>
        <li>
          <FormattedMessage id="guidance.body2" defaultMessage="Gather your evidence documents"/>
        </li>
        <li>
          <FormattedMessage id="guidance.body3"
                            defaultMessage="Preferably take evidence pictures beforehand, some devices do not allow taking a picture when filling in the form (you can select an existing picture)"/>
        </li>
        <li>
          <FormattedMessage id="guidance.body4"
                            defaultMessage="Go to {link} and choose the service area you are submitting evidence for"
                            values={{link: <Link to='/home'>the starting page</Link>}}/>
        </li>
        <li>
          <FormattedMessage id="guidance.body5"
                            defaultMessage="After selecting the service area you will need to select the evidence type. If there is no such step this means there was only one evidence type available (and it was selected for you)"/>
        </li>
        <li>
          <FormattedMessage id="guidance.body6" defaultMessage="Fill in all required details in the form"/>
        </li>
        <li>
          <FormattedHTMLMessage id="guidance.body7"
                                defaultMessage="Add evidence by selecting <code>Add Images</code>, here you will either be allowed to take a picture or will only be able to select one from available ones"/>
        </li>
        <li>
          <FormattedHTMLMessage id="guidance.body8"
                                defaultMessage="Click <code>Submit</code> and check if there are no errors on the page"/>
        </li>
        <li>
          <FormattedMessage id="guidance.body9"
                            defaultMessage="If submission was successful you will be presented with a new page showing a submission reference number"/>
        </li>
        <li>
          <FormattedMessage id="guidance.body10" defaultMessage="Store the submission reference number for your own records"/>
        </li>
      </ol>

    </React.Fragment>
  );
})
